import { property } from '@pristine-ts/metadata';
import { CalculationStatusEnum } from '../enums/calculations/calculation-status.enum';
import { CalculationKeynameEnum } from '../enums/calculations/calculation-keyname.enum';

export class CalculationIndexModel {
  @property()
  id: string;

  @property()
  organizationId: string;

  @property()
  calculationKeyname: CalculationKeynameEnum;

  @property()
  title: string;

  @property()
  status: CalculationStatusEnum;

  @property()
  updatedAt: Date;
}